<a routerLink="/" fxLayout="row" fxLayoutAlign="center center" class="logo-focusable">
  <img class="logo" [ngSrc]="getMyTeamLogo()" height="40" width="121.79" alt="Portal logo" priority=""/>
</a>

<div class="sidebar-wrapper" fxLayout="column" fxLayoutAlign="space-between">

  @for (menu of parentMenu; track menu) {
  <div class="menu-item">
    <ul class="menu-ul" *appUserRole="{ excludedRoles: menu.excludedRoles }">
      <li [routerLinkActive]="['active-parent-menu-admin']" [routerLinkActiveOptions]="{ exact: true }">
        @if (menu.routerLink && !menu.hasSubMenu) {
        <a mat-button fxLayout="row" fxLayoutAlign="start center" [routerLink]="menuService.getRouterLink(menu)"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: menu.parentId == 0 && menu.exactRouteMatch !== false }" (click)="onClick(menu.id, menu.routerLink)"
          [id]="'menu-item-'+menu.id">
          @if (menu.icon) {
          @if (menu.icon === 'forum') {
          <mat-icon class="menu-icon chat-badge" matBadge="&#8226;" matBadgeSize="small"
            [matBadgeHidden]="!unreadMessages">{{menu.icon}}</mat-icon>
          } @else if (menu.icon === 'assignment') {
          <mat-icon class="menu-icon survey-badge" matBadge="&#8226;" matBadgeSize="small"
            [matBadgeHidden]="!requestedSurveys">{{menu.icon}}</mat-icon>
          } @else if (menu.icon === 'assignment_turned_in') {
          <mat-icon class="menu-icon activities-badge" matBadge="&#8226;" matBadgeSize="small"
            [matBadgeHidden]="!activitiesBadge">{{menu.icon}}</mat-icon>
          } @else {
          <mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
          }
          }
          @if (!menu.icon) {
          <mat-icon [svgIcon]="menu.svgIcon" class="menu-icon"></mat-icon>
          }
          <span class="menu-title">{{menu.title}}</span>
        </a>
        }
      </li>
      <li [routerLinkActive]="['active-parent-menu-admin']" [routerLinkActiveOptions]="{ exact: true }">
        @if (menu.href && !menu.subMenu) {
        <a mat-button fxLayout="row" fxLayoutAlign="start center" [attr.href]="menu.href || ''"
          [attr.target]="menu.target || ''"
          [attr.rel]="menu.target === '_blank' ? 'noopener noreferrer' : null"
          (click)="onClick(menu.id, menu.href)" [id]="'menu-item-'+menu.id">
          @if (menu.icon) {
          <mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
          }
          @if (!menu.icon) {
          <mat-icon [svgIcon]="menu.svgIcon" class="menu-icon"></mat-icon>
          }
          <span class="menu-title">{{menu.title}}</span>
        </a>
        }
      </li>
      <li [routerLinkActive]="['active-parent-menu-admin']" [routerLinkActiveOptions]="{ exact: true }">
        @if (menu.hasSubMenu) {
        <a mat-button fxLayout="row" fxLayoutAlign="start center" (click)="onClick(menu.id, menu.routerLink)"
          [id]="'menu-item-'+menu.id">
          @if (menu.icon) {
          <mat-icon class="menu-icon">{{menu.icon}}</mat-icon>
          }
          @if (!menu.icon) {
          <mat-icon [svgIcon]="menu.svgIcon" class="menu-icon"></mat-icon>
          }
          <span class="menu-title">{{menu.title}}</span>
          <mat-icon class="menu-expand-icon transition-2">arrow_drop_down</mat-icon>
        </a>
        }
      </li>
    </ul>
    @if (menu.hasSubMenu) {
    <div class="sub-menu" [id]="'sub-menu-'+menu.id">
      <app-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-menu>
    </div>
    }
  </div>
  }

</div>
